import React from 'react';
import { renderWithRoot } from '../utilities/reactRoot';

import App from '../components/App';

renderWithRoot(<App />, document.getElementById('page-show-container'));
